module.exports = __webpack_public_path__ + "img/q2_2019.527fcc33.jpg";